var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Response',{attrs:{"view":"default","title":"Эта ссылка на оплату больше не работает","description":"Пожалуйста, проверьте правильность введённой ссылки или запросите новую","error-code":_vm.errorCode}})
}
var staticRenderFns = []

export { render, staticRenderFns }